import { Component, Input } from '@angular/core';
import Navigation from '../../models/navigation';
import Jurisdiction from '../../models/jurisdiction';
import { Router } from '@angular/router';

@Component({
  selector: 'app-navigation-work-orders',
  templateUrl: './navigationWorkOrders.component.html',
  styleUrls: ['./navigationWorkOrders.component.scss'],
})

export default class NavigationWorkOrdersComponent {
  model: any = {};
  crimException: HTMLInputElement;
  deferredException: HTMLInputElement;
  recordEntry: HTMLInputElement;

  constructor(protected router: Router) {
    this.showWorkOrdersByJurisdiction = false;
    this.showRetrieveWorkOrdersSection = false;
    this.showInternalSection = false;
    this.isExternal = true;
  }

  displayWorkOrdersByJurisdictionSection() {
    this.showWorkOrdersByJurisdiction = true;
  }

  displayRetrieveWorkOrdersSection() {
    this.showRetrieveWorkOrdersSection = true;
  }

  @Input() set navigation(navigation: Navigation) {
    if (navigation) {
      this.jurisdictions = navigation.jurisdictions;
    }
  }

  viewResearcherTaskListForJurisdiction(jurisdictionId: number) {
    this.router.navigate(['researcherTaskList', 'detailWork', jurisdictionId]);
  }

  changeCrimAccess(args): boolean {
    let result = false;
    if (args.target.value !== 0) {
      this.model.selection = args.target.value;

      this.crimException = <HTMLInputElement>document.getElementById('crimException');
      this.deferredException = <HTMLInputElement>document.getElementById('deferredException');
      this.recordEntry = <HTMLInputElement>document.getElementById('recordEntry');
      this.model.crimParm = (this.crimException.value === '0' && this.deferredException.value === '0') ? 'N' : 'Y';
      this.model.crimParm = (this.recordEntry.value !== '0') ? 'R' : '';
      this.navigate('CRRS', 'ChgAccess');
      result = true;
    } else {
      this.model.selection = '';
      this.model.crimParm = '';
      result =  false;
    }
    return result;
  }

  navigate(strSystem: string, task: string) {
    switch (strSystem) {
      case 'CRRS':
        switch (task) {
          case 'ByDate':
            break;
          case 'ByCase':
            break;
          case 'ByCaseAll':
            break;
          default:
            break;
        }
        break;
      case 'CTMS':
        break;
      default:
        break;
    }
  }

  loggedInUser: string;
  loggedInDate: Date;
  workOrdersByDate: object;
  showRetrieveWorkOrdersSection: boolean;
  jurisdictions: Jurisdiction[];
  workOrdersByJurisdiction: Array<object>;
  showWorkOrdersByJurisdiction: boolean;
  showInternalSection: boolean;
  isExternal: boolean;
}




// WEBPACK FOOTER //
// ./src/app/navigationWorkOrders/navigationWorkOrders.component.ts